// localStorageHelpers.ts

// Save data to localStorage
export const saveToLocalStorage = (key: string, data: any) => {
    try {
        localStorage.setItem(key, JSON.stringify(data)); // Convert data to JSON and save
        console.log(`Data successfully saved to localStorage with key: ${key}`);
    } catch (error) {
        console.error('Error saving data to localStorage:', error);
    }
};

// Fetch data from localStorage
export const fetchFromLocalStorage = (key: string) => {
    try {
        const localData = localStorage.getItem(key);
        if (localData) {
            return JSON.parse(localData); // Parse the stored JSON string back to JavaScript object
        }
        return null; // Return null if no data is found
    } catch (error) {
        console.error('Error fetching data from localStorage:', error);
        return null;
    }
};

// Clear specific data from localStorage
export const clearLocalStorage = (key: string) => {
    try {
        localStorage.removeItem(key); // Remove the item with the specified key
        console.log(`Data with key: ${key} removed from localStorage`);
    } catch (error) {
        console.error('Error clearing data from localStorage:', error);
    }
};
